import React from "react";
import { Dropdown } from "react-bootstrap";
import { UploadingDocumentPlaceholder } from "../../../documents/lib";
import { DocumentName } from "../../../documents/DocumentName";
import { AlertCircleIcon, CheckIcon } from "../../../../icons";
import { Loader } from "../../../general/Loader";
import { GridTableRow } from "../../../general/Tables/GridTable/GridTable";
import { ManagementDropdown } from "../../../general/ManagementDropdown/ManagementDropdown";
import { CaptureClicks } from "../../../general/CaptureClicks";
import styles from "./Uploader.module.scss";

interface Props {
    onRemove(): void;
    item: UploadingDocumentPlaceholder;
    onRowClick?: () => void;
}

export const UploadReceiptRow: React.FC<Props> = ({
    item,
    onRemove,
    onRowClick,
}) => {
    let status: React.ReactNode;

    if (item.financialDocument?.transactionMatches?.length) {
        status = <CheckIcon className="icon-color-blue-600" />;
    } else if (
        item.isUploading ||
        !item.financialDocument?.hasAttemptedMatching
    ) {
        status = <Loader inline />;
    } else if (!item.financialDocument.ocrSuccessful) {
        status = <AlertCircleIcon className="icon-color-yellow-600" />;
    } else {
        status = <span className="text-gray-500">•</span>;
    }

    return (
        <GridTableRow className={styles.receiptsRow} onClick={onRowClick}>
            <div>
                <DocumentName fileName={item.fileName} />
            </div>
            <div className={styles.statusValue}>{status}</div>
            <div>
                {item.financialDocument ? (
                    <CaptureClicks>
                        <ManagementDropdown
                            id={`receipt-row-dropdown-${item.financialDocument.id ?? item.fileName}`}
                        >
                            <Dropdown.Item
                                as="button"
                                onClick={onRemove}
                                disabled={item.isUploading}
                            >
                                Delete document
                            </Dropdown.Item>
                        </ManagementDropdown>
                    </CaptureClicks>
                ) : null}
            </div>
        </GridTableRow>
    );
};
